import React from 'react';
import { Container, TopContent, Group, Content, Icon, Title, Description, ButtonDiv, Link, Bottom } from './styles';
import Button from '../../../component/button';
import AppLogo from '../../../component/appLogo';
import LayoutWithoutNavbar from '../../../component/layoutWithoutNavbar';
import { BUTTON_TYPE } from '../../../global/constants';
import { observer } from 'mobx-react-lite';
import Image from '../../../component/image';

interface Props {
  onClickContinueWeb: () => void;
  onClickContinueApp: () => void;
}

const MobileOnboarding: React.FC<Props> = (props) => {
  const { onClickContinueWeb, onClickContinueApp } = props;

  return (
    <LayoutWithoutNavbar>
      <Container>
        <Group>
          <Content>
            <TopContent>
              <Icon>
                <AppLogo height='40' />
              </Icon>
              <Title>Teamcamp is best experienced using our mobile app.</Title>
              <Description>Our web app has features so big, they won’t fit on small screen.</Description>
            </TopContent>
            <ButtonDiv>
              <Button
                title='Open in free mobile app'
                variant={BUTTON_TYPE.PRIMARY}
                className='full-width'
                size='large'
                onClick={onClickContinueApp}
              />
              <Link role='button' onClick={onClickContinueWeb}>
                Continue on web anyway
              </Link>
            </ButtonDiv>
          </Content>
          <Bottom>
            <Image imageKey='mobile_onboarding' alt='taskMobile' className='first-img' width={393} height={345} />
          </Bottom>
        </Group>
      </Container>
    </LayoutWithoutNavbar>
  );
};

export default observer(MobileOnboarding);
